import { Add } from "@material-ui/icons";
import {
  Autocomplete,
  Button,
  CircularProgress,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Stack,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import CustomButton from "./Button";
import DatasetStyle from "../../../styles/Dataset";
import { useState } from "react";
import UserRolesList from "../../../../utils/UserMappedByRole/UserRolesList";
import { emailRegex } from "../../../../constants/constant";

const InviteUsersDialog = ({
  handleDialogClose,
  isOpen,
  selectedUsers,
  setSelectedUsers,
  userType,
  setUserType,
  addBtnClickHandler,
  selectedEmails,
  // csvFile,
  setSelectedEmails,
  setCsvFile,
  loading,
  btn,
  setBtn,
  value,
  setValue,
}) => {
  const classes = DatasetStyle();
  const [errorMessage, setErrorMessage] = useState({
    status: false,
    message: "",
  });
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCsvFile(file);
      parseCSV(file);
    }
  };

  const parseCSV = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      const emails = content
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line !== "" && line.includes("@"));
      setSelectedEmails(emails);
      setSelectedUsers(emails);
    };
    reader.readAsText(file);
  };

  const dialogCloseHandler = () => {
    handleDialogClose();
    setSelectedUsers([]);
    setSelectedEmails([]);
    setCsvFile(null);
    setBtn(null);
  };
  const handleKeyDown = (e) => {
    const inputValue = e.target.value.trim();

    if (e.key === "Backspace" && inputValue === "") {
      if (selectedUsers.length > 0) {
        const updatedUsers = [...selectedUsers];
        updatedUsers.pop();
        setSelectedUsers(updatedUsers);
        setSelectedEmails(updatedUsers);
      }
      return;
    }

    if (e.key === " " || e.code === "Space" || e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();

      processEmails(inputValue, e);
    }
  };

  const processEmails = (inputValue, e) => {
    if (!inputValue) return;

    const possibleEmails = inputValue
      .split(/[\s,;]+/)
      .map((email) => email.trim())
      .filter((email) => email.length > 0);

    const validEmails = possibleEmails.filter(
      (email) => emailRegex.test(email) && !selectedUsers.includes(email)
    );

    setValue("");
    if (e?.target) e.target.value = "";

    if (validEmails.length > 0) {
      const newUsers = [...selectedUsers, ...validEmails];
      setSelectedUsers(newUsers);
      setSelectedEmails(newUsers);
      setErrorMessage({ status: false, message: "" });
    } else {
      const duplicates = possibleEmails.filter((email) =>
        selectedUsers.includes(email)
      );
      const invalids = possibleEmails.filter(
        (email) => !emailRegex.test(email)
      );

      if (invalids.length > 0) {
        setErrorMessage({
          status: true,
          message: "Please enter valid email address(es)",
        });
      } else if (duplicates.length > 0) {
        setErrorMessage({
          status: true,
          message: "Email address already added",
        });
      }

      setTimeout(() => {
        setErrorMessage({ status: false, message: "" });
      }, 2000);
    }
  };

  const handleBlur = (e) => {
    const inputValue = e.target.value.trim();
    if (inputValue) {
      processEmails(inputValue, e);
    }
  };

  return (
    <Dialog open={isOpen} onClose={dialogCloseHandler} close>
      <DialogTitle style={{ paddingBottom: 0 }}>
        Invite users to organization
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={2} alignItems="center" py="1.5rem">
          {btn ? (
            <Autocomplete
              fullWidth
              multiple
              id="tags-filled"
              options={[]}
              freeSolo
              value={selectedUsers}
              clearIcon={
                <span
                  onClick={() => {
                    setSelectedUsers([]);
                    setSelectedEmails([]);
                  }}
                >
                  <ClearIcon />
                </span>
              }
              inputValue={value ?? ""}
              onInputChange={(e, newInputValue) => setValue(newInputValue)}
              renderTags={(value, getTagProps) =>
                value?.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option}
                    {...getTagProps({ index })}
                    onDelete={() =>
                      setSelectedUsers((prevValue) =>
                        prevValue.filter((email) => email !== option)
                      )
                    }
                  />
                ))
              }
              sx={{ mt: 3, mb: 3 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  variant="outlined"
                  label="Enter email ids of users to invite"
                  placeholder="Email ids"
                  defaultValue=" "
                  InputLabelProps={{
                    style: { backgroundColor: "white", fontSize: "1rem" },
                  }}
                  name={`no-suggest-${Math.random().toString(36).substring(7)}`}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "none",
                    spellCheck: "false",
                    list: "no-suggestions",
                  }}
                  onKeyDown={handleKeyDown}
                  onBlur={handleBlur}
                  error={errorMessage.status}
                  helperText={errorMessage.message}
                />
              )}
            />
          ) : (
            <Autocomplete
              fullWidth
              multiple
              id="tags-filled"
              options={[]}
              freeSolo
              value={selectedUsers}
              clearIcon={
                <span
                  onClick={() => {
                    setSelectedUsers([]);
                    setSelectedEmails([]);
                  }}
                >
                  <ClearIcon />
                </span>
              }
              inputValue={value ?? ""}
              onInputChange={(e, newInputValue) => setValue(newInputValue)}
              renderTags={(value, getTagProps) =>
                value?.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option}
                    {...getTagProps({ index })}
                    onDelete={() =>
                      setSelectedUsers((prevValue) =>
                        prevValue.filter((email) => email !== option)
                      )
                    }
                  />
                ))
              }
              sx={{ mt: 3, mb: 3 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Enter email ids of users to invite"
                  placeholder="Email ids"
                  InputLabelProps={{
                    style: { backgroundColor: "white", fontSize: "1rem" },
                  }}
                  name={`no-suggest-${Math.random().toString(36).substring(7)}`}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "none",
                    spellCheck: "false",
                    list: "no-suggestions",
                  }}
                  onBlur={handleBlur}
                  onKeyDown={handleKeyDown}
                  error={errorMessage.status}
                  helperText={errorMessage.message}
                />
              )}
            />
          )}
          <datalist id="no-suggestions"></datalist>
          <label htmlFor="upload-csv" style={{ maxHeight: "fit-content" }}>
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="upload-csv"
            />
            <Button
              variant="contained"
              color="primary"
              fullWidth
              type="button"
              className={classes.customBtn}
              component="span"
              onClick={() => {
                setBtn(true);
              }}
            >
              <AddIcon />
            </Button>
          </label>
        </Stack>
        <FormControl variant="outlined" fullWidth sx={{ width: "100%" }}>
          <InputLabel id="role-label">Select user role</InputLabel>
          <Select
            labelId="role-label"
            id="role-select"
            fullWidth
            variant="outlined"
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
            label="Select user role"
          >
            {Object.keys(UserRolesList)
              ?.slice(0, 4)
              .map((el) => (
                <MenuItem key={el} value={el}>
                  {UserRolesList[el]}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions style={{ padding: 24 }}>
        <Button onClick={dialogCloseHandler} size="small">
          Cancel
        </Button>
        <CustomButton
          startIcon={
            !loading ? (
              <Add />
            ) : (
              <CircularProgress size="0.8rem" color="secondary" />
            )
          }
          onClick={addBtnClickHandler}
          size="small"
          label="Add"
          disabled={
            loading || selectedUsers === null || selectedUsers?.length === 0
          }
        />
      </DialogActions>
    </Dialog>
  );
};

export default InviteUsersDialog;
